/**
 * Sequential Multi-Hue Color Scales
 */
export const redYellowScale = {
    100: '#FFF4C7',
    200: '#FFEB99',
    300: '#FFDC52',
    400: '#FFC73F',
    500: '#FFA722',
    600: '#FF8D0A',
    700: '#F77619',
    800: '#EC5A2C',
    900: '#E13D3D',
    1000: '#CD3636',
    1100: '#B22D2D',
    1200: '#9D2424',
    1300: '#891A1A',
    1400: '#6E1414',
    1500: '#530909',
    1600: '#320606'
};
export const purpleMagentaScale = {
    100: '#FFF4C7',
    200: '#F9D1BF',
    300: '#F3A5AF',
    400: '#ED82A3',
    500: '#E75D96',
    600: '#E3458D',
    700: '#C83E90',
    800: '#AF3892',
    900: '#953194',
    1000: '#7E2B96',
    1100: '#642498',
    1200: '#521F99',
    1300: '#42187E',
    1400: '#37136C',
    1500: '#2B0C56',
    1600: '#1E0642'
};
export const skyTealScale = {
    100: '#FFF4C7',
    200: '#CFEBC4',
    300: '#AAE4C1',
    400: '#8DDEBF',
    500: '#66D6BC',
    600: '#33CCB8',
    700: '#30BDBA',
    800: '#2CAABD',
    900: '#2899BF',
    1000: '#2487C1',
    1100: '#2075C3',
    1200: '#1C65C4',
    1300: '#1652A0',
    1400: '#103E7A',
    1500: '#092952',
    1600: '#031833'
};
/**
 * Divergent Color Scales
 */
export const skyRedScale = {
    100: '#4E0E0E',
    200: '#731A19',
    300: '#9A2E2B',
    400: '#CE4844',
    500: '#E76057',
    600: '#ED8876',
    700: '#F4AD91',
    800: '#FAD4AF',
    900: '#FFF4C7',
    1000: '#C8DACD',
    1100: '#94C1D2',
    1200: '#5EA7D7',
    1300: '#1E88DD',
    1400: '#0F72C6',
    1500: '#0B5193',
    1600: '#083A6E',
    1700: '#06254D',
    1800: '#1A1A1A'
};
export const indigoMagentaScale = {
    100: '#580C2E',
    200: '#74113E',
    300: '#9D2359',
    400: '#C23571',
    500: '#D74781',
    600: '#E47F99',
    700: '#ECA2AB',
    800: '#F2CED1',
    900: '#F4E5E6',
    1000: '#D3CEE2',
    1100: '#A6ADDE',
    1200: '#7D8BE6',
    1300: '#5A6ADD',
    1400: '#3F53D1',
    1500: '#2D3EAB',
    1600: '#1C2B87',
    1700: '#0F1C6B',
    1800: '#1A1A1A'
};
export const tealOrangeScale = {
    100: '#563004',
    200: '#6F3E07',
    300: '#8E500A',
    400: '#AD620D',
    500: '#CA7310',
    600: '#D9933C',
    700: '#E6B56D',
    800: '#F3D59B',
    900: '#FFF4C7',
    1000: '#CCE1BB',
    1100: '#96CCAE',
    1200: '#5EB7A0',
    1300: '#279D8D',
    1400: '#1F8375',
    1500: '#17665C',
    1600: '#0E4941',
    1700: '#07342D',
    1800: '#1A1A1A'
};
export const purpleTealScale = {
    100: '#07342D',
    200: '#0E4941',
    300: '#17665C',
    400: '#1F8375',
    500: '#279D8D',
    600: '#5EB7A0',
    700: '#96CCAE',
    800: '#CCE1BB',
    900: '#FFF4C7',
    1000: '#E1CCC8',
    1100: '#BE9DC8',
    1200: '#A277C8',
    1300: '#844EC8',
    1400: '#6A34B5',
    1500: '#562797',
    1600: '#441B7C',
    1700: '#2F0D5D',
    1800: '#1A1A1A'
};
//# sourceMappingURL=multi_hue_color.js.map